/* How pages are laid onto leaves, as arithmetic.
 *
 * This is here because getting it wrong made half the manual unreachable and
 * nothing noticed. A leaf carries two pages — front and back — which is
 * exactly right on a spread: turn it and its back becomes the new left-hand
 * page. In a single column it is a trap. The leaf is clipped to one page and
 * swings clear of that box when it turns, so what you see next is the NEXT
 * LEAF'S FRONT and its own back is never shown at all. Every even page was
 * unreachable on a phone, including two of the three charms, and the first
 * person to read it asked where the second tool was.
 *
 * So: a spread gets leaves of two pages, a single column gets leaves of one.
 * Kept as a pure function so `test/soak.ts` can ask the question that
 * matters — is every page reachable, in both layouts — without a browser.
 */

/** The pages on each leaf, in order. `back` is null on a one-page leaf: the
 *  reverse of the sheet, which carries nothing but stops the paper being
 *  see-through while it turns. */
export function binding(pageCount, single) {
  const per = single ? 1 : 2;
  const leaves: any[] = [];
  for (let i = 0; i < pageCount; i += per) {
    leaves.push({ front: i, back: per === 2 && i + 1 < pageCount ? i + 1 : null });
  }
  return leaves;
}

/** Every page a reader can actually get to. In a single column only the fronts
 *  are ever shown, because a turned leaf leaves the visible area entirely. */
export function readable(pageCount, single) {
  const out: any[] = [];
  for (const leaf of binding(pageCount, single)) {
    out.push(leaf.front);
    if (!single && leaf.back != null) out.push(leaf.back);
  }
  return out.filter((i) => i != null && i < pageCount);
}
